// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"238":"component---src-pages-storyblok-entry-full-slug-js","351":"commons","802":"94726e6d","883":"component---src-pages-404-js"}[chunkId] + "-" + {"238":"4995eb250227d3d10bdd","351":"bfd36d78f24714ef0de0","802":"4f5356edfe68697ff9c3","883":"679869b8e7f531934414"}[chunkId] + ".js";
};